module.exports = __webpack_public_path__ + "static/img/thumb_3.b20d9ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_3.jpg
// module id = +I5W
// module chunks = 0